import { Component, ContentChildren, ElementRef, EventEmitter, Input, Output, QueryList, ViewChild } from '@angular/core';
import { AccordionService } from "./accordion.service";
import { AccordionItemComponent } from "./components/accordion-item/accordion-item.component";


@Component({
    selector: 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    providers: [AccordionService]
})
export class AccordionComponent {
    @ViewChild('accordion', {static: false}) accordion: ElementRef;

    @ContentChildren(AccordionItemComponent) items: QueryList<AccordionItemComponent>;

    @Input() label = '';
    @Output() select = new EventEmitter<any>();


    constructor() {
    }

}
